import { GetterTree } from 'vuex'
import { RootState } from '@/app/common/types/root-state.type'
import { MyUploadedDocumentState } from './state'
import { MyUploadedDocument } from '@/app/my-uploaded-documents/entities/my-uploaded-document.entity'

export const getters: GetterTree<MyUploadedDocumentState, RootState> = {
    sortedDocuments(state: MyUploadedDocumentState): MyUploadedDocument[] {
        return [...state.documents].sort((a: MyUploadedDocument, b: MyUploadedDocument) => {
            const aTime = new Date(a.uploadedAt).getTime()
            const bTime = new Date(b.uploadedAt).getTime()
            return bTime - aTime
        })
    }
}


